import { formatarDadosParaTexto } from './formatadorDados';

export function buildMedicalTextForLuxor({
  data,
  infosPaciente,
  filteredConditions,
  filteredAllergies,
  filteredImmunizations,
  textoInterventions
}: {
  data: any,
  infosPaciente: any,
  filteredConditions?: any[],
  filteredAllergies?: any[],
  filteredImmunizations?: any[],
  textoInterventions?: string
}) {
  const textoFormatado = formatarDadosParaTexto(
    data,
    infosPaciente,
    undefined, // Não usar mais filteredTreatments
    filteredConditions,
    filteredAllergies,
    filteredImmunizations
  );
  return textoFormatado + (textoInterventions ? `\n\n${textoInterventions}` : "");
}

export async function generateMedicalTextAndCopy({
  data,
  infosPaciente,
  filteredConditions,
  filteredAllergies,
  filteredImmunizations,
  textoInterventions,
  setContent,
  onSuccess,
  onError
}: {
  data: any,
  infosPaciente: any,
  filteredConditions?: any[],
  filteredAllergies?: any[],
  filteredImmunizations?: any[],
  textoInterventions?: string,
  setContent: (text: string) => void,
  onSuccess?: (text: string) => void,
  onError?: (err: any) => void
}) {
  const textoFinal = buildMedicalTextForLuxor({
    data,
    infosPaciente,
    filteredConditions,
    filteredAllergies,
    filteredImmunizations,
    textoInterventions
  });
  try {
    await navigator.clipboard.writeText(textoFinal);
    setContent(textoFinal);
    if (onSuccess) onSuccess(textoFinal);
  } catch (err) {
    if (onError) onError(err);
  }
} 